<template>
  <section>
    <button class="button field is-primary pull-right" @click="create">
      <b-icon icon="plus" />
      <span>New</span>
    </button>
    <b-table :data="paymentMethods" :loading="loading" striped>
      <template slot-scope="props">
        <b-table-column label="Name" field="name">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column label="Actions" :width="200">
          <router-link :to="`/payment_methods/${props.row.id}/edit`">
            <button class="button">Edit</button>
          </router-link>
          <button @click.prevent="remove(props.row.id, props.index)" class="button">Remove</button>
        </b-table-column>
      </template>
      <template slot="empty" v-if="!loading">
        <empty />
      </template>
    </b-table>
  </section>
</template>

<script>
import http from '@/lib/utils/http'
import Empty from '@/lib/components/Empty'

export default {
  data() {
    return {
      paymentMethods: [],
      loading: false,
    }
  },
  components: {
    empty: Empty,
  },
  methods: {
    create() {
      this.$router.push('/payment_methods/new')
    },
    remove(paymentMethodId, index) {
      http
        .delete(`payment_methods/${paymentMethodId}`)
        .then(() => {
          this.paymentMethods.splice(index, 1)
        })
        .catch(() => {})
    },
    load() {
      this.loading = true
      http
        .get('payment_methods')
        .then(resp => (this.paymentMethods = resp.data))
        .catch(() => {})
        .then(() => (this.loading = false))
    },
  },
  created() {
    this.load()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/PaymentMethods/List.vue